// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"AttachmentsList_pageHeader__18gDn"};